<div class="body-bind">
  <div class="header-wrap">
    <header>
      <div class="horizontal-menu">
        <div class="left-menu">
          <h1 (click)="goDashboard()">
            <img
              style="object-fit: contain; object-position: left"
              [src]="logo"
              alt=""
            />
          </h1>

          <div *ngIf="checkCompany; then allMenu; else partMenu"></div>
          <ul>
            <ng-template #allMenu>
              <ul>
                <li (click)="goDashboard()" class="gnb">
                  <span class="main-menu">대시보드</span>
                </li>
                <li class="gnb">
                  <span class="main-menu">주문/승인</span>
                  <ul class="sub">
                    <li (click)="goOrder()"><span>주문</span></li>
                    <li (click)="goManufacture()">
                      <span>생산/출하 승인</span>
                    </li>
                  </ul>
                </li>
                <li class="gnb">
                  <span class="main-menu">분석</span>
                  <ul class="sub detection">
                    <li (click)="goAnalysis()"><span>분석</span></li>
                    <li (click)="goCompanyProfit()"><span>영업이익률</span></li>
                    <li (click)="goLeadTime()">
                      <span>수주출하리드타임</span>
                    </li>
                    <li (click)="goDeadlineInfo()"><span>납기단축</span></li>
                  </ul>
                </li>
                <li class="gnb">
                  <span class="main-menu">자재/생산품</span>
                  <ul class="sub detection">
                    <li (click)="goProduct()"><span>품목</span></li>
                    <li (click)="goBom()">
                      <span>BOM</span>
                    </li>
                    <li (click)="goProcess()"><span>공정</span></li>
                    <li (click)="redirectToUrl('material')">
                      <span>자재</span>
                    </li>
                  </ul>
                </li>

                <li (click)="goClient()" class="gnb">
                  <span class="main-menu">거래처</span>
                </li>
              </ul>
            </ng-template>

            <ng-template #partMenu>
              <ul *ngIf="wdSize">
                <li (click)="goDashboard()" class="gnb">
                  <span class="main-menu">대시보드</span>
                </li>
                <li (click)="goOrder()" class="gnb">
                  <span class="main-menu">주문</span>
                </li>
                <li (click)="goProduct()" class="gnb" *ngIf="wdSize">
                  <span class="main-menu">품목</span>
                </li>
                <li (click)="goClient()" class="gnb" *ngIf="wdSize">
                  <span class="main-menu">거래처</span>
                </li>
              </ul>
            </ng-template>

            <li class="gnb" *ngIf="wdSize">
              <span class="main-menu">환경감지</span>
              <ul class="sub detection">
                <li (click)="redirectToUrl('detector-information')">
                  <span>감지기 정보/그래프</span>
                </li>
                <li (click)="redirectToUrl('detector-history-information')">
                  <span>감지기 이력정보</span>
                </li>
                <li (click)="redirectToUrl('alarm-history')">
                  <span>위험사항 알림정보</span>
                </li>
                <li (click)="redirectToUrl('drawing-management')">
                  <span>도면관리</span>
                </li>
              </ul>
            </li>
            <li class="gnb" *ngIf="wdSize">
              <span class="main-menu">설정</span>
              <ul class="sub detection">
                <li (click)="goSetting()">
                  <span>단위설정</span>
                </li>
                <li (click)="redirectToUrl('alarm-user-setting')">
                  <span>알림정보 설정</span>
                </li>
                <li (click)="redirectToUrl('user-manage')">
                  <span>사용자 설정</span>
                </li>
                <li *ngIf="position !== '직원'" (click)="goLogHistory()">
                  <span>사용자 이력</span>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <div class="button-wrap">
          <button
            class="alarm-button"
            (click)="goManufacture()"
            *ngIf="checkCompany"
          >
            <img src="assets/img/alarm-icon.png" alt="" />
            <span *ngIf="data.waitOrderCount > 0">{{
              data.waitOrderCount | number
            }}</span>
          </button>
          <span *ngIf="roleText">{{ roleText }}</span>
          <button class="profile">
            <img src="assets/img/profile-icon.png" alt="" />
          </button>
          <div class="btn-group" ngbDropdown>
            <button type="button" class="dropdown-toggle" ngbDropdownToggle>
              <span>{{ name }}</span>
              <span>{{ position }}</span>
              <img
                src="assets/img/drop-down-icon.png"
                class="arrow-icon"
                alt=""
              />
            </button>
            <div class="dropdown-menu" ngbDropdownMenu>
              <a
                class="dropdown-item"
                href="javascript: void(0);"
                (click)="logout()"
                >로그아웃</a
              >
            </div>
          </div>
        </div>

        <div class="right-bar-enabled" (click)="mbMenu()">
          <img class="right-menu-bar" src="../../assets/img/menu-mobile.svg" />
        </div>
      </div>
    </header>
  </div>

  <div class="metismenu" *ngIf="mbMenuShow">
    <ul>
      <li (click)="goDashboard(); mbMenu()">대시보드</li>
      <li (click)="goOrder(); mbMenu()">주문</li>
      <li (click)="logout(); mbMenu()">로그아웃</li>
    </ul>
  </div>

  <div class="main-content">
    <div class="page-content">
      <!-- content -->
      <router-outlet></router-outlet>
    </div>
  </div>

  <footer *ngIf="mbShow">
    <div class="con">
      <p>Copyright ⓒ 2024 C&TECH Corp. ALL Rights Reserved | version.1.5.0</p>
    </div>
  </footer>
</div>

<!-- </div> -->
